import React, { Component, Fragment } from 'react';
import Table from './Table';
import Paginate from './Paginate';

export default class TableLayout extends Component {
    render(){
        const { data, loading} = this.props
        const { error } = this.props;
        if (error) {
            return (
                <div className="rounded-0 alert alert-warning m-0">
                    Não foi possível carregar a lista de transações.
                </div>
            );
        }
        if (loading){
            return (
                <div className="rounded-0 alert alert-light m-0">
                    Carregando...
                </div>
            );
        } else {
            const {pages} = this.props;
            const {initialPage} = this.props;
            const {onPageClick} = this.props;
            return (
                <Fragment>
                    <div className='card shadow mb-6'>
                        <div className='card-header'>
                            <div className='row align-items-center'>
                                <div className='col-8'>
                                    <h5 className='h3 mb-0'>Transações</h5>
                                </div>
                                <h3 className='mb-0'></h3>
                            </div>
                        </div>
                        <Table payments={data}/>
                        <Paginate pages={pages} initialPage={initialPage} onPageClick={onPageClick} />
                    </div>
                </Fragment>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Payments/TableLayout.js